import React from 'react';
import { useAppStore } from '../../store/appStore';

const TYPE_ICONS = {
  success: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ flexShrink: 0 }}>
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  error: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ flexShrink: 0 }}>
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  ),
  warning: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ flexShrink: 0 }}>
      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  ),
  info: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ flexShrink: 0 }}>
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
    </svg>
  ),
};

export default function ToastContainer() {
  const { toasts, removeToast } = useAppStore();

  if (toasts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      maxWidth: '420px',
      minWidth: '300px',
    }}>
      {toasts.map(t => {
        const type = t.type || 'info';
        const colorMap = {
          success: 'var(--accent-green)',
          error:   'var(--accent-red)',
          warning: 'var(--accent-orange)',
          info:    'var(--accent-cyan)',
        };
        const bgMap = {
          success: 'rgba(0,255,136,0.07)',
          error:   'rgba(255,51,102,0.1)',
          warning: 'rgba(244,123,32,0.1)',
          info:    'rgba(0,212,255,0.07)',
        };
        const color = colorMap[type] || colorMap.info;
        const bg = bgMap[type] || bgMap.info;
        const isPersistent = type === 'error' || type === 'warning';

        return (
          <div
            key={t.id}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
              padding: '14px 16px',
              background: 'var(--bg-elevated)',
              border: `1px solid ${color}`,
              borderLeft: `4px solid ${color}`,
              borderRadius: 'var(--radius-md)',
              boxShadow: `0 4px 24px rgba(0,0,0,0.5), 0 0 0 1px ${color}22`,
              color,
              fontFamily: 'var(--font-display)',
              fontSize: '13px',
              fontWeight: 600,
              letterSpacing: '0.04em',
              animation: 'slideUp 0.2s ease',
              backgroundColor: bg,
            }}
          >
            {/* Icon */}
            {TYPE_ICONS[type]}

            {/* Message */}
            <div style={{ flex: 1, lineHeight: 1.4 }}>
              {t.message}
              {isPersistent && (
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', fontWeight: 400, opacity: 0.6, marginTop: '4px' }}>
                  Click × to dismiss
                </div>
              )}
            </div>

            {/* Dismiss button */}
            <button
              onClick={() => removeToast(t.id)}
              style={{
                background: 'none',
                border: 'none',
                color,
                cursor: 'pointer',
                padding: '0',
                fontSize: '18px',
                lineHeight: 1,
                opacity: 0.7,
                flexShrink: 0,
                marginTop: '-2px',
              }}
              onMouseEnter={e => e.currentTarget.style.opacity = '1'}
              onMouseLeave={e => e.currentTarget.style.opacity = '0.7'}
              title="Dismiss"
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}
